<template>
    <div id="workspace_setting" class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label">Tìm kiếm</label>
                <vs-input class="w-full" v-model="keySearch" placeholder="Nhập tên ..."></vs-input>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                <label class="vs-input--label">Trạng thái</label>
                <v-select class="w-full" v-model="selectedstatusValue" :options="statusOptions" :clearable="false"
                          name="" :reduce="item => item.value">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 w-full">
                <div class="flex">
                    <vs-button class="lg:mt-6 mt-4" @click="search" iconPack="feather" icon="icon-search">Tìm kiếm</vs-button>
                    <vs-button class="lg:mt-6 mt-4 ml-auto" @click="$router.push('/user/workspace-setting-info')" iconPack="feather" icon="icon-plus">Thêm mới</vs-button>
                </div>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                             class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                             :defaultColDef="defaultColDef"
                             :rowData="workspaceData" :animateRows="true" :pagination="true"
                             :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                             :onGridReady="onGridReady"
                             :suppressPaginationPanel="true">
                </ag-grid-vue>

                <div class="vx-row" v-if="workspaceData.length > 0">
                    <div class="vx-col md:w-1/2">
                        <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                            <span class="vx-col mt-2">Số phần tử / trang:</span>
                            <vs-dropdown vs-trigger-click class="cursor-pointer">
                                <div
                                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        workspaceData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : workspaceData.length
                                    }} /
                                    {{ totalElements }}</span>
                                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                                </div>
                                <vs-dropdown-menu>
                                    <vs-dropdown-item @click="changePageSize(20)">
                                        <span>20</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="changePageSize(30)">
                                        <span>30</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="changePageSize(50)">
                                        <span>50</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="changePageSize(100)">
                                        <span>100</span>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from './cell-renderer/CellRendererActions';
import CellRendererIcons from './cell-renderer/CellRendererIcons';

export default {
    name: "WorkspaceSetting",
    components: {
        vSelect,
        AgGridVue,
        CellRendererActions,
        CellRendererIcons
    },
    data() {
        return {
            statusOptions: [
                {value: null, label: 'Tất cả'},
                {value: 0, label: 'Đang hoạt động'},
                {value: 1, label: 'Ngừng hoạt động'},
            ],
            keySearch: null,
            selectedstatusValue: null,
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            totalElements: 0,
            currentPage: 1,
            workspaceData: [],
            gridApi: null,
            gridOptions: {
                rowHeight: 70
            },
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'Vị trí',
                    field: 'orders',
                    width: 50
                },
                {
                    headerName: 'Tên App',
                    field: 'nameIconApp',
                    width: 100
                },
                {
                    headerName: 'Đường link',
                    field: 'urlApp',
                    width: 100
                },
                {
                    headerName: 'Icon',
                    field: 'icon',
                    width: 80,
                    cellRendererFramework: 'CellRendererIcons',
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 80,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
        }
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isDeleteWorkspace'(val) {
            if (val) {
                this.search();
                this.$store.commit('DELETE_WORKSPACE_SUCCESS', false);
            }
        }
    },

    created() {
        this.getAllWorkspace();
    },

    methods: {
        getAllWorkspace() {
            this.$vs.loading();
            let payload = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                keySearch: this.keySearch,
                status: this.selectedstatusValue,
                workspaceData: [],
            }
            this.$crm.post('/setting/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.workspaceData = res.data.content;
                } else {
                    this.workspaceData = []
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllWorkspace();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getAllWorkspace();
        },

        search() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getAllWorkspace();
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>
</style>

<style lang="scss">
#workspace_setting .ag-theme-material  .ag-cell {
    line-height: 70px !important;
}

.grid-cell-centered {
    text-align: center;
    justify-content: center;
}
</style>
